export const amplifyOutputs = {
  "auth": {
    "user_pool_id": "eu-west-1_TtgJ1oJlz",
    "aws_region": "eu-west-1",
    "user_pool_client_id": "7smhihn2koefavaep9n5esp87n",
    "identity_pool_id": "eu-west-1:0490daeb-77b3-4e44-adc4-af00db8a8d4a",
    "mfa_methods": [],
    "standard_required_attributes": [
      "email"
    ],
    "username_attributes": [
      "email"
    ],
    "user_verification_types": [
      "email"
    ],
    "mfa_configuration": "NONE",
    "password_policy": {
      "min_length": 8,
      "require_lowercase": true,
      "require_numbers": true,
      "require_symbols": true,
      "require_uppercase": true
    },
    "oauth": {
      "identity_providers": [],
      "redirect_sign_in_uri": [
        "https://dalia.syskoplan.cloud",
        "https://www.dalia.syskoplan.cloud"
      ],
      "redirect_sign_out_uri": [
        "https://dalia.syskoplan.cloud",
        "https://www.dalia.syskoplan.cloud"
      ],
      "response_type": "code",
      "scopes": [
        "phone",
        "email",
        "openid",
        "profile",
        "aws.cognito.signin.user.admin"
      ],
      "domain": "1830b75baf70af5cf94e.auth.eu-west-1.amazoncognito.com"
    },
    "unauthenticated_identities_enabled": true
  },
  "data": {
    "url": "https://2sy4gk6pnfetvj5albb2lozmoi.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_region": "eu-west-1",
    "api_key": "da2-fbmqupkxj5fejoy2pcqe7r6gnu",
    "default_authorization_type": "AWS_IAM",
    "authorization_types": [
      "API_KEY",
      "AMAZON_COGNITO_USER_POOLS"
    ],
    "model_introspection": {
      "version": 1,
      "models": {
        "Organization": {
          "name": "Organization",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "name": {
              "name": "name",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "address": {
              "name": "address",
              "isArray": false,
              "type": {
                "nonModel": "OrganizationAddress"
              },
              "isRequired": false,
              "attributes": []
            },
            "status": {
              "name": "status",
              "isArray": false,
              "type": {
                "enum": "Status"
              },
              "isRequired": true,
              "attributes": []
            },
            "autoApprove": {
              "name": "autoApprove",
              "isArray": false,
              "type": "Boolean",
              "isRequired": true,
              "attributes": []
            },
            "teamCalendar": {
              "name": "teamCalendar",
              "isArray": false,
              "type": "Boolean",
              "isRequired": true,
              "attributes": []
            },
            "negativeBalance": {
              "name": "negativeBalance",
              "isArray": false,
              "type": "Boolean",
              "isRequired": true,
              "attributes": []
            },
            "mfaActive": {
              "name": "mfaActive",
              "isArray": false,
              "type": "Boolean",
              "isRequired": true,
              "attributes": []
            },
            "notificationsActive": {
              "name": "notificationsActive",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false,
              "attributes": []
            },
            "departments": {
              "name": "departments",
              "isArray": true,
              "type": {
                "model": "Department"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "organizationId"
                ]
              }
            },
            "holidays": {
              "name": "holidays",
              "isArray": true,
              "type": {
                "model": "Holiday"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "organizationId"
                ]
              }
            },
            "leaveTypes": {
              "name": "leaveTypes",
              "isArray": true,
              "type": {
                "model": "LeaveType"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "organizationId"
                ]
              }
            },
            "contracts": {
              "name": "contracts",
              "isArray": true,
              "type": {
                "model": "Contract"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "organizationId"
                ]
              }
            },
            "projects": {
              "name": "projects",
              "isArray": true,
              "type": {
                "model": "Project"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "organizationId"
                ]
              }
            },
            "orgOwnerId": {
              "name": "orgOwnerId",
              "isArray": false,
              "type": "ID",
              "isRequired": false,
              "attributes": []
            },
            "orgOwner": {
              "name": "orgOwner",
              "isArray": false,
              "type": {
                "model": "User"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "orgOwnerId"
                ]
              }
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "Organizations",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "read",
                      "update"
                    ],
                    "groups": [
                      "ADMINS",
                      "OWNERS"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "Department": {
          "name": "Department",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "name": {
              "name": "name",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "status": {
              "name": "status",
              "isArray": false,
              "type": {
                "enum": "Status"
              },
              "isRequired": true,
              "attributes": []
            },
            "organizationId": {
              "name": "organizationId",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "organization": {
              "name": "organization",
              "isArray": false,
              "type": {
                "model": "Organization"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "organizationId"
                ]
              }
            },
            "teams": {
              "name": "teams",
              "isArray": true,
              "type": {
                "model": "Team"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "departmentId"
                ]
              }
            },
            "managers": {
              "name": "managers",
              "isArray": true,
              "type": {
                "model": "DepartmentManager"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "departmentId"
                ]
              }
            },
            "users": {
              "name": "users",
              "isArray": true,
              "type": {
                "model": "User"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "departmentId"
                ]
              }
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "Departments",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "groups": [
                      "ADMINS",
                      "OWNERS"
                    ],
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "read",
                      "update"
                    ],
                    "groups": [
                      "MANAGERS"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "DepartmentManager": {
          "name": "DepartmentManager",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "departmentId": {
              "name": "departmentId",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "userId": {
              "name": "userId",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "department": {
              "name": "department",
              "isArray": false,
              "type": {
                "model": "Department"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "departmentId"
                ]
              }
            },
            "user": {
              "name": "user",
              "isArray": false,
              "type": {
                "model": "User"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "userId"
                ]
              }
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "DepartmentManagers",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "groups": [
                      "ADMINS",
                      "OWNERS",
                      "MANAGERS"
                    ],
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "Team": {
          "name": "Team",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "name": {
              "name": "name",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "status": {
              "name": "status",
              "isArray": false,
              "type": {
                "enum": "Status"
              },
              "isRequired": true,
              "attributes": []
            },
            "departmentId": {
              "name": "departmentId",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "department": {
              "name": "department",
              "isArray": false,
              "type": {
                "model": "Department"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "departmentId"
                ]
              }
            },
            "users": {
              "name": "users",
              "isArray": true,
              "type": {
                "model": "User"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "teamId"
                ]
              }
            },
            "leads": {
              "name": "leads",
              "isArray": true,
              "type": {
                "model": "TeamLead"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "teamId"
                ]
              }
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "Teams",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "groups": [
                      "ADMINS",
                      "OWNERS"
                    ],
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "read",
                      "create",
                      "update"
                    ],
                    "groups": [
                      "MANAGERS"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "read",
                      "update"
                    ],
                    "groups": [
                      "TEAMLEADS"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "TeamLead": {
          "name": "TeamLead",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "teamId": {
              "name": "teamId",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "userId": {
              "name": "userId",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "team": {
              "name": "team",
              "isArray": false,
              "type": {
                "model": "Team"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "teamId"
                ]
              }
            },
            "user": {
              "name": "user",
              "isArray": false,
              "type": {
                "model": "User"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "userId"
                ]
              }
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "TeamLeads",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "groups": [
                      "ADMINS",
                      "OWNERS",
                      "MANAGERS"
                    ],
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "Project": {
          "name": "Project",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "name": {
              "name": "name",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "description": {
              "name": "description",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "status": {
              "name": "status",
              "isArray": false,
              "type": {
                "enum": "Status"
              },
              "isRequired": true,
              "attributes": []
            },
            "organizationId": {
              "name": "organizationId",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "organization": {
              "name": "organization",
              "isArray": false,
              "type": {
                "model": "Organization"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "organizationId"
                ]
              }
            },
            "users": {
              "name": "users",
              "isArray": true,
              "type": {
                "model": "ProjectUser"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "projectId"
                ]
              }
            },
            "leads": {
              "name": "leads",
              "isArray": true,
              "type": {
                "model": "ProjectLead"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "projectId"
                ]
              }
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "Projects",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "groups": [
                      "ADMINS",
                      "OWNERS"
                    ],
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "read",
                      "create",
                      "update"
                    ],
                    "groups": [
                      "PROJECTLEADS"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "ProjectLead": {
          "name": "ProjectLead",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "projectId": {
              "name": "projectId",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "userId": {
              "name": "userId",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "project": {
              "name": "project",
              "isArray": false,
              "type": {
                "model": "Project"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "projectId"
                ]
              }
            },
            "user": {
              "name": "user",
              "isArray": false,
              "type": {
                "model": "User"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "userId"
                ]
              }
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "ProjectLeads",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "groups": [
                      "ADMINS",
                      "OWNERS",
                      "PROJECTLEADS"
                    ],
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "ProjectUser": {
          "name": "ProjectUser",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "projectId": {
              "name": "projectId",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "userId": {
              "name": "userId",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "project": {
              "name": "project",
              "isArray": false,
              "type": {
                "model": "Project"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "projectId"
                ]
              }
            },
            "user": {
              "name": "user",
              "isArray": false,
              "type": {
                "model": "User"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "userId"
                ]
              }
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "ProjectUsers",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "groups": [
                      "ADMINS",
                      "OWNERS",
                      "PROJECTLEADS"
                    ],
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "User": {
          "name": "User",
          "fields": {
            "userId": {
              "name": "userId",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "email": {
              "name": "email",
              "isArray": false,
              "type": "AWSEmail",
              "isRequired": true,
              "attributes": []
            },
            "firstName": {
              "name": "firstName",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "lastName": {
              "name": "lastName",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "status": {
              "name": "status",
              "isArray": false,
              "type": {
                "enum": "Status"
              },
              "isRequired": true,
              "attributes": []
            },
            "position": {
              "name": "position",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "country": {
              "name": "country",
              "isArray": false,
              "type": {
                "enum": "Country"
              },
              "isRequired": false,
              "attributes": []
            },
            "entryDate": {
              "name": "entryDate",
              "isArray": false,
              "type": "AWSDate",
              "isRequired": false,
              "attributes": []
            },
            "resignationDate": {
              "name": "resignationDate",
              "isArray": false,
              "type": "AWSDate",
              "isRequired": false,
              "attributes": []
            },
            "autoApprove": {
              "name": "autoApprove",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false,
              "attributes": []
            },
            "federalState": {
              "name": "federalState",
              "isArray": false,
              "type": {
                "enum": "FederalState"
              },
              "isRequired": false,
              "attributes": []
            },
            "balance": {
              "name": "balance",
              "isArray": false,
              "type": "Float",
              "isRequired": false,
              "attributes": []
            },
            "teamId": {
              "name": "teamId",
              "isArray": false,
              "type": "ID",
              "isRequired": false,
              "attributes": []
            },
            "team": {
              "name": "team",
              "isArray": false,
              "type": {
                "model": "Team"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "teamId"
                ]
              }
            },
            "departmentId": {
              "name": "departmentId",
              "isArray": false,
              "type": "ID",
              "isRequired": false,
              "attributes": []
            },
            "department": {
              "name": "department",
              "isArray": false,
              "type": {
                "model": "Department"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "departmentId"
                ]
              }
            },
            "orgOwner": {
              "name": "orgOwner",
              "isArray": false,
              "type": {
                "model": "Organization"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "HAS_ONE",
                "associatedWith": [
                  "orgOwnerId"
                ],
                "targetNames": []
              }
            },
            "manager": {
              "name": "manager",
              "isArray": true,
              "type": {
                "model": "DepartmentManager"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "userId"
                ]
              }
            },
            "lead": {
              "name": "lead",
              "isArray": true,
              "type": {
                "model": "TeamLead"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "userId"
                ]
              }
            },
            "projectLeads": {
              "name": "projectLeads",
              "isArray": true,
              "type": {
                "model": "ProjectLead"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "userId"
                ]
              }
            },
            "projectUsers": {
              "name": "projectUsers",
              "isArray": true,
              "type": {
                "model": "ProjectUser"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "userId"
                ]
              }
            },
            "contractId": {
              "name": "contractId",
              "isArray": false,
              "type": "ID",
              "isRequired": false,
              "attributes": []
            },
            "contract": {
              "name": "contract",
              "isArray": false,
              "type": {
                "model": "Contract"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "contractId"
                ]
              }
            },
            "transactions": {
              "name": "transactions",
              "isArray": true,
              "type": {
                "model": "Transaction"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "userId"
                ]
              }
            },
            "leaves": {
              "name": "leaves",
              "isArray": true,
              "type": {
                "model": "Leave"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "userId"
                ]
              }
            },
            "substitutes": {
              "name": "substitutes",
              "isArray": true,
              "type": {
                "model": "Leave"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "substituteId"
                ]
              }
            },
            "approvals": {
              "name": "approvals",
              "isArray": true,
              "type": {
                "model": "Leave"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "approverId"
                ]
              }
            },
            "notifications": {
              "name": "notifications",
              "isArray": true,
              "type": {
                "model": "Notification"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "userId"
                ]
              }
            },
            "approvalRecords": {
              "name": "approvalRecords",
              "isArray": true,
              "type": {
                "model": "ApprovalRecord"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "updatedById"
                ]
              }
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "Users",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "key",
              "properties": {
                "fields": [
                  "userId"
                ]
              }
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "groups": [
                      "ADMINS",
                      "OWNERS"
                    ],
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "read"
                    ],
                    "groups": [
                      "USERS"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": true,
            "primaryKeyFieldName": "userId",
            "sortKeyFieldNames": []
          }
        },
        "PendingUsers": {
          "name": "PendingUsers",
          "fields": {
            "email": {
              "name": "email",
              "isArray": false,
              "type": "AWSEmail",
              "isRequired": true,
              "attributes": []
            },
            "firstName": {
              "name": "firstName",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "lastName": {
              "name": "lastName",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "position": {
              "name": "position",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "country": {
              "name": "country",
              "isArray": false,
              "type": {
                "enum": "Country"
              },
              "isRequired": false,
              "attributes": []
            },
            "entryDate": {
              "name": "entryDate",
              "isArray": false,
              "type": "AWSDate",
              "isRequired": false,
              "attributes": []
            },
            "resignationDate": {
              "name": "resignationDate",
              "isArray": false,
              "type": "AWSDate",
              "isRequired": false,
              "attributes": []
            },
            "autoApprove": {
              "name": "autoApprove",
              "isArray": false,
              "type": "Boolean",
              "isRequired": true,
              "attributes": []
            },
            "federalState": {
              "name": "federalState",
              "isArray": false,
              "type": {
                "enum": "FederalState"
              },
              "isRequired": false,
              "attributes": []
            },
            "balance": {
              "name": "balance",
              "isArray": false,
              "type": "Float",
              "isRequired": false,
              "attributes": []
            },
            "teamId": {
              "name": "teamId",
              "isArray": false,
              "type": "ID",
              "isRequired": false,
              "attributes": []
            },
            "departmentId": {
              "name": "departmentId",
              "isArray": false,
              "type": "ID",
              "isRequired": false,
              "attributes": []
            },
            "contractId": {
              "name": "contractId",
              "isArray": false,
              "type": "ID",
              "isRequired": false,
              "attributes": []
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "PendingUsers",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "key",
              "properties": {
                "fields": [
                  "email"
                ]
              }
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "groups": [
                      "ADMINS",
                      "OWNERS"
                    ],
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": true,
            "primaryKeyFieldName": "email",
            "sortKeyFieldNames": []
          }
        },
        "Transaction": {
          "name": "Transaction",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "type": {
              "name": "type",
              "isArray": false,
              "type": {
                "enum": "TransactionType"
              },
              "isRequired": false,
              "attributes": []
            },
            "description": {
              "name": "description",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "amount": {
              "name": "amount",
              "isArray": false,
              "type": "Float",
              "isRequired": true,
              "attributes": []
            },
            "timestamp": {
              "name": "timestamp",
              "isArray": false,
              "type": "AWSTimestamp",
              "isRequired": true,
              "attributes": []
            },
            "userId": {
              "name": "userId",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "user": {
              "name": "user",
              "isArray": false,
              "type": {
                "model": "User"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "userId"
                ]
              }
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "Transactions",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "read"
                    ],
                    "groups": [
                      "ADMINS",
                      "OWNERS"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "Contract": {
          "name": "Contract",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "name": {
              "name": "name",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "status": {
              "name": "status",
              "isArray": false,
              "type": {
                "enum": "Status"
              },
              "isRequired": true,
              "attributes": []
            },
            "days": {
              "name": "days",
              "isArray": false,
              "type": "Float",
              "isRequired": true,
              "attributes": []
            },
            "workingHours": {
              "name": "workingHours",
              "isArray": true,
              "type": {
                "nonModel": "WorkingHours"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true
            },
            "users": {
              "name": "users",
              "isArray": true,
              "type": {
                "model": "User"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "contractId"
                ]
              }
            },
            "organizationId": {
              "name": "organizationId",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "organization": {
              "name": "organization",
              "isArray": false,
              "type": {
                "model": "Organization"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "organizationId"
                ]
              }
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "Contracts",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "groups": [
                      "ADMINS",
                      "OWNERS"
                    ],
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "Leave": {
          "name": "Leave",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "status": {
              "name": "status",
              "isArray": false,
              "type": {
                "enum": "LeaveStatus"
              },
              "isRequired": true,
              "attributes": []
            },
            "startDate": {
              "name": "startDate",
              "isArray": false,
              "type": "AWSDate",
              "isRequired": true,
              "attributes": []
            },
            "endDate": {
              "name": "endDate",
              "isArray": false,
              "type": "AWSDate",
              "isRequired": true,
              "attributes": []
            },
            "isStartHalfDay": {
              "name": "isStartHalfDay",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false,
              "attributes": []
            },
            "isEndHalfDay": {
              "name": "isEndHalfDay",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false,
              "attributes": []
            },
            "days": {
              "name": "days",
              "isArray": false,
              "type": "Float",
              "isRequired": false,
              "attributes": []
            },
            "commentApplicant": {
              "name": "commentApplicant",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "commentApprover": {
              "name": "commentApprover",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "approveTimestamp": {
              "name": "approveTimestamp",
              "isArray": false,
              "type": "AWSTimestamp",
              "isRequired": false,
              "attributes": []
            },
            "userId": {
              "name": "userId",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "user": {
              "name": "user",
              "isArray": false,
              "type": {
                "model": "User"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "userId"
                ]
              }
            },
            "approverId": {
              "name": "approverId",
              "isArray": false,
              "type": "ID",
              "isRequired": false,
              "attributes": []
            },
            "approver": {
              "name": "approver",
              "isArray": false,
              "type": {
                "model": "User"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "approverId"
                ]
              }
            },
            "substituteId": {
              "name": "substituteId",
              "isArray": false,
              "type": "ID",
              "isRequired": false,
              "attributes": []
            },
            "substitute": {
              "name": "substitute",
              "isArray": false,
              "type": {
                "model": "User"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "substituteId"
                ]
              }
            },
            "leaveTypeId": {
              "name": "leaveTypeId",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "leaveType": {
              "name": "leaveType",
              "isArray": false,
              "type": {
                "model": "LeaveType"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "leaveTypeId"
                ]
              }
            },
            "approvalRecords": {
              "name": "approvalRecords",
              "isArray": true,
              "type": {
                "model": "ApprovalRecord"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "leaveId"
                ]
              }
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "Leaves",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "read"
                    ],
                    "groups": [
                      "USERS"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "groups": [
                      "ADMINS",
                      "OWNERS"
                    ],
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "ApprovalRecord": {
          "name": "ApprovalRecord",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "description": {
              "name": "description",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "leaveId": {
              "name": "leaveId",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "leave": {
              "name": "leave",
              "isArray": false,
              "type": {
                "model": "Leave"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "leaveId"
                ]
              }
            },
            "updatedById": {
              "name": "updatedById",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "updatedBy": {
              "name": "updatedBy",
              "isArray": false,
              "type": {
                "model": "User"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "updatedById"
                ]
              }
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "ApprovalRecords",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "read"
                    ],
                    "groups": [
                      "USERS"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "groups": [
                      "ADMINS",
                      "OWNERS"
                    ],
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "LeaveType": {
          "name": "LeaveType",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "name": {
              "name": "name",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "status": {
              "name": "status",
              "isArray": false,
              "type": {
                "enum": "Status"
              },
              "isRequired": true,
              "attributes": []
            },
            "isSpecialType": {
              "name": "isSpecialType",
              "isArray": false,
              "type": "Boolean",
              "isRequired": true,
              "attributes": []
            },
            "days": {
              "name": "days",
              "isArray": false,
              "type": "Float",
              "isRequired": true,
              "attributes": []
            },
            "leaves": {
              "name": "leaves",
              "isArray": true,
              "type": {
                "model": "Leave"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "leaveTypeId"
                ]
              }
            },
            "organizationId": {
              "name": "organizationId",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "organization": {
              "name": "organization",
              "isArray": false,
              "type": {
                "model": "Organization"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "organizationId"
                ]
              }
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "LeaveTypes",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "read"
                    ],
                    "groups": [
                      "USERS"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "groups": [
                      "ADMINS",
                      "OWNERS"
                    ],
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "Holiday": {
          "name": "Holiday",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "name": {
              "name": "name",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "status": {
              "name": "status",
              "isArray": false,
              "type": {
                "enum": "Status"
              },
              "isRequired": true,
              "attributes": []
            },
            "halfDay": {
              "name": "halfDay",
              "isArray": false,
              "type": "Boolean",
              "isRequired": true,
              "attributes": []
            },
            "date": {
              "name": "date",
              "isArray": false,
              "type": "AWSDate",
              "isRequired": true,
              "attributes": []
            },
            "country": {
              "name": "country",
              "isArray": false,
              "type": {
                "enum": "Country"
              },
              "isRequired": true,
              "attributes": []
            },
            "organizationId": {
              "name": "organizationId",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "organization": {
              "name": "organization",
              "isArray": false,
              "type": {
                "model": "Organization"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "organizationId"
                ]
              }
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "Holidays",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "read"
                    ],
                    "groups": [
                      "USERS"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "groups": [
                      "ADMINS",
                      "OWNERS"
                    ],
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "Notification": {
          "name": "Notification",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "userId": {
              "name": "userId",
              "isArray": false,
              "type": "ID",
              "isRequired": false,
              "attributes": []
            },
            "user": {
              "name": "user",
              "isArray": false,
              "type": {
                "model": "User"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "userId"
                ]
              }
            },
            "type": {
              "name": "type",
              "isArray": false,
              "type": {
                "enum": "NotificationType"
              },
              "isRequired": true,
              "attributes": []
            },
            "message": {
              "name": "message",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "read": {
              "name": "read",
              "isArray": false,
              "type": "Boolean",
              "isRequired": true,
              "attributes": []
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "Notifications",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "read"
                    ],
                    "groups": [
                      "USERS"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "groups": [
                      "ADMINS",
                      "OWNERS"
                    ],
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        }
      },
      "enums": {
        "Status": {
          "name": "Status",
          "values": [
            "ACTIVE",
            "ARCHIVED",
            "REMOVED"
          ]
        },
        "Country": {
          "name": "Country",
          "values": [
            "DE",
            "PL",
            "OTHER"
          ]
        },
        "FederalState": {
          "name": "FederalState",
          "values": [
            "BW",
            "BY",
            "BE",
            "BB",
            "HB",
            "HH",
            "HE",
            "MV",
            "NI",
            "NW",
            "RP",
            "SL",
            "SN",
            "ST",
            "SH",
            "TH",
            "OTHER"
          ]
        },
        "LeaveStatus": {
          "name": "LeaveStatus",
          "values": [
            "PENDING",
            "APPROVED",
            "AUTO_APPROVED",
            "REJECTED",
            "CANCELLED"
          ]
        },
        "NotificationType": {
          "name": "NotificationType",
          "values": [
            "LEAVE_REQUEST",
            "LEAVE_APPROVAL",
            "LEAVE_REJECTION",
            "LEAVE_CANCELLATION"
          ]
        },
        "TransactionType": {
          "name": "TransactionType",
          "values": [
            "LEAVE",
            "ADJUSTMENT"
          ]
        }
      },
      "nonModels": {
        "WorkingHours": {
          "name": "WorkingHours",
          "fields": {
            "day": {
              "name": "day",
              "isArray": false,
              "type": "Int",
              "isRequired": true,
              "attributes": []
            },
            "hours": {
              "name": "hours",
              "isArray": false,
              "type": "Float",
              "isRequired": true,
              "attributes": []
            }
          }
        },
        "OrganizationAddress": {
          "name": "OrganizationAddress",
          "fields": {
            "street": {
              "name": "street",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "city": {
              "name": "city",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "postalCode": {
              "name": "postalCode",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "country": {
              "name": "country",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            }
          }
        }
      },
      "queries": {
        "getUserData": {
          "name": "getUserData",
          "isArray": false,
          "type": "AWSJSON",
          "isRequired": false,
          "arguments": {
            "userId": {
              "name": "userId",
              "isArray": false,
              "type": "ID",
              "isRequired": true
            },
            "accessToken": {
              "name": "accessToken",
              "isArray": false,
              "type": "String",
              "isRequired": true
            }
          }
        },
        "getProjectData": {
          "name": "getProjectData",
          "isArray": false,
          "type": "AWSJSON",
          "isRequired": false,
          "arguments": {
            "projectId": {
              "name": "projectId",
              "isArray": false,
              "type": "ID",
              "isRequired": true
            },
            "accessToken": {
              "name": "accessToken",
              "isArray": false,
              "type": "String",
              "isRequired": true
            }
          }
        },
        "getCalendarData": {
          "name": "getCalendarData",
          "isArray": false,
          "type": "AWSJSON",
          "isRequired": false,
          "arguments": {
            "userId": {
              "name": "userId",
              "isArray": false,
              "type": "ID",
              "isRequired": true
            },
            "accessToken": {
              "name": "accessToken",
              "isArray": false,
              "type": "String",
              "isRequired": true
            }
          }
        },
        "getTeamData": {
          "name": "getTeamData",
          "isArray": false,
          "type": "AWSJSON",
          "isRequired": false,
          "arguments": {
            "teamId": {
              "name": "teamId",
              "isArray": false,
              "type": "ID",
              "isRequired": true
            },
            "accessToken": {
              "name": "accessToken",
              "isArray": false,
              "type": "String",
              "isRequired": true
            }
          }
        },
        "getDepartmentData": {
          "name": "getDepartmentData",
          "isArray": false,
          "type": "AWSJSON",
          "isRequired": false,
          "arguments": {
            "departmentId": {
              "name": "departmentId",
              "isArray": false,
              "type": "ID",
              "isRequired": true
            },
            "accessToken": {
              "name": "accessToken",
              "isArray": false,
              "type": "String",
              "isRequired": true
            }
          }
        },
        "getOrganizationData": {
          "name": "getOrganizationData",
          "isArray": false,
          "type": "AWSJSON",
          "isRequired": false,
          "arguments": {
            "organizationId": {
              "name": "organizationId",
              "isArray": false,
              "type": "ID",
              "isRequired": true
            }
          }
        },
        "getDispoData": {
          "name": "getDispoData",
          "isArray": false,
          "type": "AWSJSON",
          "isRequired": false,
          "arguments": {
            "projectId": {
              "name": "projectId",
              "isArray": false,
              "type": "ID",
              "isRequired": false
            },
            "teamId": {
              "name": "teamId",
              "isArray": false,
              "type": "ID",
              "isRequired": false
            },
            "departmentId": {
              "name": "departmentId",
              "isArray": false,
              "type": "ID",
              "isRequired": false
            },
            "year": {
              "name": "year",
              "isArray": false,
              "type": "Int",
              "isRequired": true
            },
            "leaveType": {
              "name": "leaveType",
              "isArray": false,
              "type": "String",
              "isRequired": true
            }
          }
        },
        "calculateVacationDays": {
          "name": "calculateVacationDays",
          "isArray": false,
          "type": "AWSJSON",
          "isRequired": false,
          "arguments": {
            "start": {
              "name": "start",
              "isArray": false,
              "type": "AWSDate",
              "isRequired": true
            },
            "end": {
              "name": "end",
              "isArray": false,
              "type": "AWSDate",
              "isRequired": true
            },
            "country": {
              "name": "country",
              "isArray": false,
              "type": "String",
              "isRequired": true
            },
            "federalState": {
              "name": "federalState",
              "isArray": false,
              "type": "String",
              "isRequired": true
            },
            "isStartHalfDay": {
              "name": "isStartHalfDay",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false
            },
            "isEndHalfDay": {
              "name": "isEndHalfDay",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false
            }
          }
        },
        "standInAvailability": {
          "name": "standInAvailability",
          "isArray": false,
          "type": "AWSJSON",
          "isRequired": false,
          "arguments": {
            "start": {
              "name": "start",
              "isArray": false,
              "type": "AWSDate",
              "isRequired": true
            },
            "end": {
              "name": "end",
              "isArray": false,
              "type": "AWSDate",
              "isRequired": true
            },
            "standInID": {
              "name": "standInID",
              "isArray": false,
              "type": "ID",
              "isRequired": true
            }
          }
        },
        "listGroupsForUser": {
          "name": "listGroupsForUser",
          "isArray": false,
          "type": "AWSJSON",
          "isRequired": false,
          "arguments": {
            "userId": {
              "name": "userId",
              "isArray": false,
              "type": "ID",
              "isRequired": true
            }
          }
        },
        "listUsersInGroup": {
          "name": "listUsersInGroup",
          "isArray": false,
          "type": "AWSJSON",
          "isRequired": false,
          "arguments": {
            "groupName": {
              "name": "groupName",
              "isArray": false,
              "type": "String",
              "isRequired": true
            }
          }
        },
        "listCalendars": {
          "name": "listCalendars",
          "isArray": false,
          "type": "AWSJSON",
          "isRequired": false,
          "arguments": {
            "userId": {
              "name": "userId",
              "isArray": false,
              "type": "ID",
              "isRequired": true
            }
          }
        }
      },
      "mutations": {
        "createUserComplete": {
          "name": "createUserComplete",
          "isArray": false,
          "type": "AWSJSON",
          "isRequired": false,
          "arguments": {
            "email": {
              "name": "email",
              "isArray": false,
              "type": "AWSEmail",
              "isRequired": true
            },
            "firstName": {
              "name": "firstName",
              "isArray": false,
              "type": "String",
              "isRequired": true
            },
            "lastName": {
              "name": "lastName",
              "isArray": false,
              "type": "String",
              "isRequired": true
            },
            "position": {
              "name": "position",
              "isArray": false,
              "type": "String",
              "isRequired": false
            },
            "country": {
              "name": "country",
              "isArray": false,
              "type": "String",
              "isRequired": true
            },
            "entryDate": {
              "name": "entryDate",
              "isArray": false,
              "type": "AWSDate",
              "isRequired": true
            },
            "autoApprove": {
              "name": "autoApprove",
              "isArray": false,
              "type": "Boolean",
              "isRequired": true
            },
            "federalState": {
              "name": "federalState",
              "isArray": false,
              "type": "String",
              "isRequired": true
            },
            "teamId": {
              "name": "teamId",
              "isArray": false,
              "type": "String",
              "isRequired": false
            },
            "contractId": {
              "name": "contractId",
              "isArray": false,
              "type": "String",
              "isRequired": false
            }
          }
        },
        "deleteUserComplete": {
          "name": "deleteUserComplete",
          "isArray": false,
          "type": "AWSJSON",
          "isRequired": false,
          "arguments": {
            "userId": {
              "name": "userId",
              "isArray": false,
              "type": "ID",
              "isRequired": true
            }
          }
        },
        "addUserToGroup": {
          "name": "addUserToGroup",
          "isArray": false,
          "type": "AWSJSON",
          "isRequired": false,
          "arguments": {
            "userId": {
              "name": "userId",
              "isArray": false,
              "type": "ID",
              "isRequired": true
            },
            "group": {
              "name": "group",
              "isArray": false,
              "type": "String",
              "isRequired": true
            }
          }
        },
        "removeUserFromGroup": {
          "name": "removeUserFromGroup",
          "isArray": false,
          "type": "AWSJSON",
          "isRequired": false,
          "arguments": {
            "userId": {
              "name": "userId",
              "isArray": false,
              "type": "ID",
              "isRequired": true
            },
            "group": {
              "name": "group",
              "isArray": false,
              "type": "String",
              "isRequired": true
            }
          }
        },
        "createLeaveRequest": {
          "name": "createLeaveRequest",
          "isArray": false,
          "type": "AWSJSON",
          "isRequired": false,
          "arguments": {
            "userId": {
              "name": "userId",
              "isArray": false,
              "type": "ID",
              "isRequired": true
            },
            "start": {
              "name": "start",
              "isArray": false,
              "type": "AWSDate",
              "isRequired": true
            },
            "end": {
              "name": "end",
              "isArray": false,
              "type": "AWSDate",
              "isRequired": true
            },
            "leaveTypeId": {
              "name": "leaveTypeId",
              "isArray": false,
              "type": "ID",
              "isRequired": true
            },
            "substituteId": {
              "name": "substituteId",
              "isArray": false,
              "type": "String",
              "isRequired": false
            },
            "commentApplicant": {
              "name": "commentApplicant",
              "isArray": false,
              "type": "String",
              "isRequired": false
            },
            "isStartHalfDay": {
              "name": "isStartHalfDay",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false
            },
            "isEndHalfDay": {
              "name": "isEndHalfDay",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false
            }
          }
        },
        "updateLeaveRequest": {
          "name": "updateLeaveRequest",
          "isArray": false,
          "type": "AWSJSON",
          "isRequired": false,
          "arguments": {
            "userId": {
              "name": "userId",
              "isArray": false,
              "type": "ID",
              "isRequired": true
            },
            "leaveId": {
              "name": "leaveId",
              "isArray": false,
              "type": "ID",
              "isRequired": true
            },
            "substituteId": {
              "name": "substituteId",
              "isArray": false,
              "type": "String",
              "isRequired": false
            },
            "commentApplicant": {
              "name": "commentApplicant",
              "isArray": false,
              "type": "String",
              "isRequired": false
            },
            "status": {
              "name": "status",
              "isArray": false,
              "type": "String",
              "isRequired": false
            }
          }
        },
        "processLeaveRequest": {
          "name": "processLeaveRequest",
          "isArray": false,
          "type": "AWSJSON",
          "isRequired": false,
          "arguments": {
            "leaveId": {
              "name": "leaveId",
              "isArray": false,
              "type": "ID",
              "isRequired": true
            },
            "approverId": {
              "name": "approverId",
              "isArray": false,
              "type": "ID",
              "isRequired": true
            },
            "leaveStatus": {
              "name": "leaveStatus",
              "isArray": false,
              "type": "String",
              "isRequired": true
            },
            "commentApprover": {
              "name": "commentApprover",
              "isArray": false,
              "type": "String",
              "isRequired": false
            }
          }
        },
        "updateUserData": {
          "name": "updateUserData",
          "isArray": false,
          "type": "AWSJSON",
          "isRequired": false,
          "arguments": {
            "email": {
              "name": "email",
              "isArray": false,
              "type": "AWSEmail",
              "isRequired": true
            },
            "firstName": {
              "name": "firstName",
              "isArray": false,
              "type": "String",
              "isRequired": true
            },
            "lastName": {
              "name": "lastName",
              "isArray": false,
              "type": "String",
              "isRequired": true
            },
            "position": {
              "name": "position",
              "isArray": false,
              "type": "String",
              "isRequired": false
            },
            "entryDate": {
              "name": "entryDate",
              "isArray": false,
              "type": "AWSDate",
              "isRequired": true
            },
            "federalState": {
              "name": "federalState",
              "isArray": false,
              "type": "String",
              "isRequired": true
            },
            "country": {
              "name": "country",
              "isArray": false,
              "type": "String",
              "isRequired": true
            }
          }
        }
      }
    }
  },
  "version": "1.1"
};
